function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#418fde"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,18.333h30v1.111H0v1.111h30v1.111H0v-3.333Z",
    style: {
      fill: "#ffd100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.139,8.75l-.694-2.25-.694,2.25-2.25.694,2.25.694.694,2.25.694-2.25,2.25-.694-2.25-.694Z",
    style: {
      fill: "#ef3340"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.444,12.766l-.783-2.538-2.538-.783,2.538-.783.783-2.538.783,2.538,2.538.783-2.538.783-.783,2.538ZM1.877,9.444l1.962.606.606,1.962.606-1.962,1.962-.606-1.962-.606-.606-1.962-.606,1.962-1.962.606Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAw);
export default __webpack_public_path__ + "static/media/AW.76a9b6a328a41a26fcea9929eda9bc47.svg";
export { ForwardRef as ReactComponent };